
<main class="reference_form-main">
  <div class="main_container">
    <form [formGroup]="terrainForm">
    <div class="">
      <h3 class="form_name">Terrain</h3>


        <div class="input">
          <label for="">Terrain Name</label>
          <input type="text" class="default_input reference-form" formControlName="TerrainName" />

          <label for="">Rate</label>
          <input type="text" class="default_input reference-form" formControlName="Rate" />

          <label for="">Status</label>
            <select name="" class="default_input reference-form" formControlName="Status" >
                <option  value="Active">Active</option>
                <option  value="Inactive">Inactive</option>
            </select>

          <label for="">Date</label>
          <input type="date" class="default_input reference-form" formControlName="TerrainDate" />

          <label for="">Remarks</label>
          <input type="text" class="default_input reference-form" formControlName="Remarks" />

        </div>


      <div class="btn_holder">
        <button class="default_primary-button" *ngIf="selectedIndex === null" (click)="addNew(terrainForm.value)">Add</button>
        <button class="default_primary-button" *ngIf="selectedIndex !== null"
            (click)="addNew(terrainForm.value)">Update</button>
        <button class="default_secondary-btn ml-2" (click)="onClearForm()">Reset</button>

      </div>

    </div>
  </form>
    <div class="display_table">
      <div class="search_container">
        <input type="text" class="default_input search"
        placeholder="Search for Terrain"
        [formControl]="control"
        [appAutocomplete]="autocomplete"
        />
        <em class="ti-search"></em> 

        <app-autocomplete #autocomplete="appAutocomplete">
          <ng-template appAutocompleteContent>
            <ng-container
              *ngIf="(terrains | filterReference: control.value) as result"
            >
              <app-option
                (click)="selectTerrain(option.id)"
                *ngFor="let option of result"
                [value]="option.TerrainName"
              >
                {{ option.TerrainName }}
              </app-option>
              <app-option class="no-result" *ngIf="!result.length"
                >No result...</app-option
              >
            </ng-container>
          </ng-template>
        </app-autocomplete>
      </div>

      <div class="head" >
        <span class="item">S/N</span>
        <span class="item">Terrain Name</span>
        <span class="item">Rate</span>
        <span class="item">Status</span>
        <span class="item">Remarks</span>
        <span class="item">Date</span>
        <span class="item">Action</span>

      </div>

    <div class="scroll">

    </div>
    <div class="body_content" >
      <div class="the_body"
      *ngFor="let terrain of terrainFormArray.get('Terrains')['controls']; index as i"
      (click)="onEdit(i, terrain.value)" style="cursor: pointer;"
      matTooltip="Click to edit"
        aria-label="Button that displays a tooltip when focused or hovered over"
      >
        <span class="content">{{i + 1}}</span>
        <span class="content">{{terrain.value.TerrainName}}</span>
        <span class="content">{{terrain.value.Rate}}</span>
        <span class="content">{{terrain.value.Status}}</span>
        <span class="content">{{terrain.value.Remarks}}</span>
        <span class="content">{{terrain.value.TerrainDate | date:"dd/MM/yyyy"}}</span>
        <span class="content" (click)="$event.stopImmediatePropagation()">
          <button
          class="delete_icon trash"

          (click)="deleteTerrain(i, terrain.value)">
          <em class="ti-trash"> </em> </button>
        </span>

      </div>
      </div>
      <div class="btn_holder">
        <button class="default_primary-button" (click)="onSubmit(terrainFormArray.value)">Submit</button>
      </div>
    </div>
  </div>
</main>

<div class="box green_box"></div>
<div class="box pink_box"></div>
